module.exports = __webpack_public_path__ + "static/media/customer-story-zervant-hero.1b743bcd.webp";